export interface ICropSettings {
  SourceX: number,
  SourceY: number,
  SourceWidth: number,
  SourceHeight: number
}


export interface IAssetPayload {
  id: number;
  idString: string;
  subType: string;
  cropX?: number;
  cropY?: number;
  cropWidth?: number;
  cropHeight?: number;
}

export enum AssociationType {
  Image191x100 = 'Image191x100',
  Image178x100 = 'Image178x100',
  Image172x100 = 'Image172x100',
  Image169x100 = 'Image169x100',
  Image155x100 = 'Image155x100',
  Image150x100 = 'Image150x100',
  Image133x100 = 'Image133x100',
  Image1x1 = 'Image1x1',
  Image93x100 = 'Image93x100',
  OriginalImage = 'OriginalImage',
}

export interface IImageExperienceImage {
  setIncluded(val: boolean): void;
  isMaunalCropped(): boolean;
  isManualEdited(val: boolean): boolean;
  setCropSettings(cropSettings: ICropSettings): void;
  formatToSave(isMultimediaAd?: boolean, isVideoThumbnail?: boolean, overrideInfo?: any, isMMAV2Enabled?: boolean, isImageFittingEnabled?: boolean): IAssetPayload;
  copyEffectsFromOther(another: IImageExperienceImage): void;
  setType(AssociationType): void;
  isLogo: boolean;
  IsIncluded: boolean;
  isAutoCropping: boolean;
  Type: AssociationType;
  Id: string;
  IdString: string;
  isVirtual?: boolean;
  Width: number;
  Height: number;
  FinalSrc: string;
  CropSettings?: ICropSettings;
  BaseId?: number;
  associationType: string;
  originalImageCropSettings?: ICropSettings;
}

export interface IImageAssetUpdate {
  id: number;
}

export interface IImageExperienceImageWithUpdate {
  finalIdString: string;
  image: IImageExperienceImage;
}

export interface IImageInfo {
  url: string,
  width: number,
  height: number,
  baseId: string,
  metadata: string,
  sourceType: string;
  isRecommendedImage: boolean;
  originalUrl: string;
  cropSettingOnOriginal: ICropSettings,
  placementSettings: Array<ICropSettings>,
  originalWidth: number,
  originalHeight: number,

}

export interface IImageMapUrl {
  [key: string]: IImageInfo,
}

export interface IMTAsset {
  Id: string,
  SubType: string,
  CropX: number,
  CropY: number,
  CropWidth: number,
  CropHeight: number,
  CroppingType: string,
  IdString: string,
  ImageUrl: string;
  Height: number;
  Width: number;
  AltText: string,
}

interface ITextAsset {
  Asset: {
    Text: string;
    AssetType: string;
  }
}

export interface IImageAsset {
  Asset: IMTAsset;
}

export interface IRecommendAd {
  FinalUrls: string[];
  Text: string;
  Headline: string;
  LongHeadline: string;
  BusinessName: string;
  Headlines: ITextAsset[];
  Descriptions: ITextAsset[];
  LongHeadlines: ITextAsset[];
  Images: IImageAsset[];
}

export interface IAdRecommendResponse {
  value: IRecommendAd[];
}

export interface IActivityLogger {
  signal: (args0: string, args1: string) => void;
}

export interface ISetUpAdWithRecommendAdParam {
  ad: IRecommendAd,
  isAdEditShown?: boolean,
  shouldSaveAdFromRecommend: boolean,
}

export interface ResponsiveAdForPreview {
  images: IImageExperienceImage[][],
  shortHeadline: string;
  longHeadline: string;
  description: string;
  businessName: string;
  url: string;
}
